import React from "react";
import { motion } from "framer-motion";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { Container, ContentWithPaddingXl } from "components/misc/Layouts";
import { useTranslation } from "react-i18next";
import BgTitle from "components/title/BgTitle";
import reinforcementImg from "images/itservice/v2/reinforcement.jpg";
import leaseImg from "images/itservice/v2/lease.jpeg";
import chineseImg from "images/itservice/v2/chinese-business.jpg";
import systemDevImg from "images/itservice/v2/ses-dev.jpg";
import systeEngImg from "images/itservice/v2/ses.jpg";
import ItServicesListMobileView from "./ItServicesListMobileView";

const BgWrapper = styled.div`
  ${tw`fancy-feature-mask bg-gray-100`}
`;
const TabContent = tw(motion.div)`mt-8 flex flex-wrap justify-start -mx-4`;
const CardContainer = tw.div`px-2 w-full sm:w-1/2 md:w-1/4 lg:w-1/5 mb-10`;
const Card = styled(motion.div)`
  ${tw`rounded-lg overflow-hidden shadow-lg flex flex-col h-full bg-white`}
  transition: box-shadow 0.3s ease;

  &:hover {
    ${tw`shadow-2xl`}
  }
`;
const CardImageContainer = styled.div`
  ${(props) =>
    css`
      background-image: url("${props.imageSrc}");
    `}
  ${tw`h-32 bg-center bg-cover relative rounded-t-lg overflow-hidden`}
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.1);
  }
`;

const CardText = tw.div`p-6 flex flex-col flex-grow`;
const CardTitle = tw.h5`text-sm font-semibold text-gray-800`;
const CardContent = tw.p`mt-2 text-xs text-gray-600 flex-grow leading-relaxed`;
const CardButton = styled.a`
  ${tw`mt-4 inline-flex items-center text-ncc font-semibold transition-all duration-300 cursor-pointer`}
  i {
    ${tw`ml-2`}
  }
`;

export default ({ isXs = false }) => {
  const { t } = useTranslation();

  if (isXs) return <ItServicesListMobileView />;

  const tabs = {
    Starters: [
      {
        imageSrc: systemDevImg,
        title: t("home_section3_service1_title"),
        content: t("home_section3_service1_desc"),
        url: "/it-service",
      },
      {
        imageSrc: systeEngImg,
        title: t("home_section3_service2_title"),
        content: t("home_section3_service2_desc"),
        url: "/business#system-engineering",
      },
      {
        imageSrc: reinforcementImg,
        title: t("home_section3_service3_title"),
        content: t("home_section3_service3_desc"),
        url: "/business-reinforcement",
      },
      {
        imageSrc: leaseImg,
        title: t("home_section3_service5_title"),
        content: t("home_section3_service5_desc"),
        url: "/business#lease-business",
      },
      {
        imageSrc: chineseImg,
        title: t("home_section3_service6_title"),
        content: t("home_section3_service6_desc"),
        url: "/business#chinese-market",
      },
    ],
  };

  return (
    <BgWrapper>
      <Container>
        <ContentWithPaddingXl>
          <BgTitle text={t("home_section3_title")} />
          <TabContent>
            {tabs.Starters.map((card, index) => (
              <CardContainer key={index}>
                <Card className="group">
                  <CardImageContainer imageSrc={card.imageSrc} />
                  <CardText>
                    <CardTitle>{card.title}</CardTitle>
                    <CardContent>{card.content}</CardContent>
                    <CardButton href={card.url}>
                      {t("home_section3_btn")}{" "}
                      <i className="fa-solid fa-arrow-right"></i>
                    </CardButton>
                  </CardText>
                </Card>
              </CardContainer>
            ))}
          </TabContent>
        </ContentWithPaddingXl>
      </Container>
    </BgWrapper>
  );
};
